import { TemplateRef } from '@angular/core';

export interface CopyConfig<T> {
  allowCopying?: boolean;
  onCopySelectedRows?: (...rows: T[]) => void;
  copyRowsTemplate?: TemplateRef<any>;
}
